import { theme } from "@/tailwind.config"
import { ScaleLoader } from "react-spinners"

interface SpinnerProps {
  hasTitle?: boolean
  title?: string
  cover?: boolean
}

export function Spinner({
  hasTitle = false,
  title = "Loading data...",
  cover = true,
}: SpinnerProps) {
  return (
    <div
      className={`flex ${cover ? "h-[calc(100vh-8rem)]" : ""} flex-col items-center justify-center py-6`}>
      <div>
        <ScaleLoader
          color={theme.colors.primary[600]}
          aria-label="Loading Spinner"
          height={40}
          width={6}
          radius={6}
          margin={4}
        />
      </div>
      {hasTitle ?
        <div className="px-8">
          <p className="font-medium">{title}</p>
        </div>
      : null}
    </div>
  )
}
